<template>
  <content-page />
</template>

<script setup lang="ts">
  import { defineAsyncComponent } from 'vue';
  import { useAsyncData, useNuxtApp, useRoute } from 'nuxt/app';
  import { useContentsStore } from '~~/common/stores/contents';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface';

  const ContentPage = defineAsyncComponent(() => import('~~/shop/app/components/Page/Content/Page.vue'));

  defineOptions({
    name: 'ContentPage',
  });

  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });

  const { $logger } = useNuxtApp();
  const { params } = useRoute();
  const contentsStore = useContentsStore();
  const userInterfaceStore = useUserInterfaceStore();

  await useAsyncData(
    `content_${params.id}`,
    async () => {
      try {
        const id = String(params.id);
        await contentsStore.fetchContent({ pageId: id });
        userInterfaceStore.setBackground({ ...contentsStore.data });
      } catch (err) {
        $logger.error(err);
      }
      return {};
    },
  );
</script>
